import {LitElement, html, css} from 'lit'
import Panel from 'bui/presenters/panel'
import waiver from './waiver-html'
import waiverAdult from './waiver-adult'
import waiverStaff from './waiver-staff'

customElements.defineShared('steens-registration-waiver', class extends LitElement{

    static get styles(){return css`
        :host {
            display: grid;
            grid-template-rows: auto 1fr auto;
            height: 100%;
        }

        b-panel-toolbar {
            font-family: var(--font-header);
        }

        main {
            overflow: auto;
            padding: 1em;
            padding-bottom: calc(2em + env(safe-area-inset-bottom));
            font-size: .8em;
            line-height: 1.3em;
        }
    `}
	
	render(){return html`
        <b-panel-toolbar notitle overlay>
            <span slot="close-btn"></span>
        </b-panel-toolbar>
		<main>
            
            ${this.waiver}

            <br>
            <b-btn pill color="theme" block lg @click=${this.close}>Close</b-btn>
        </main>
	`}

    close(){
        this.panel.close()
    }

    get shirt(){
        return {
            'l':'Large',
            'm': 'Medium',
            's': 'Small',
            'xs': 'Extra Small'
        }[this.data.shirt] || '?'
    }

    open(opts={}){
        
        this.panel = this.panel || new Panel(this, Object.assign({
            title: 'Waiver',
            width: '700px',
            anchor: 'center',
            quickJump: false,
            disableBackdropClick: true
        }, opts))

        
        this.waiver = waiver

        if( opts.version == 'adult' )
            this.waiver = waiverAdult
        
        if( opts.version == 'staff' )
            this.waiver = waiverStaff

        this.panel.open()
    }

})

export default customElements.get('steens-registration-waiver')